<script lang="ts">
	interface Props {
		dirty: boolean;
		saving?: boolean;
		error?: string | null;
		message?: string;
		onsave: () => void;
		ondiscard: () => void;
	}
	let {
		dirty,
		saving = false,
		error = null,
		message = 'Есть несохранённые изменения',
		onsave,
		ondiscard
	}: Props = $props();
</script>

{#if dirty || saving || error}
	<div class="admin-save-bar" aria-busy={saving}>
		<p aria-live="polite" class:error>{error || (saving ? 'Сохраняем…' : message)}</p>
		<div class="actions">
			<button type="button" disabled={saving || !dirty} onclick={ondiscard}>Отменить</button>
			<button type="button" class="primary" disabled={saving || !dirty} onclick={onsave}
				>{saving ? 'Сохраняем…' : 'Сохранить'}</button
			>
		</div>
	</div>
{/if}

<style>
	.admin-save-bar {
		position: sticky;
		bottom: 0;
		z-index: var(--z-sticky);
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		gap: var(--spacing-s);
		min-height: var(--admin-savebar-height);
		padding: var(--spacing-m) var(--spacing-l);
		border-top: var(--size-1) solid var(--border-subtle);
		background: var(--background-card);
	}
	p {
		flex: 1 1 auto;
		margin: 0;
		color: var(--text-secondary);
		font-size: var(--font-size-s);
		overflow-wrap: anywhere;
	}
	p.error {
		color: var(--status-danger);
	}
	.actions {
		display: flex;
		flex-wrap: wrap;
		gap: var(--spacing-s);
	}
	button {
		min-height: var(--admin-touch-target);
		padding: var(--spacing-s) var(--spacing-l);
		border: var(--size-1) solid var(--border-subtle);
		border-radius: var(--radius-s);
		background: var(--background-secondary);
		color: var(--text-primary);
		font: inherit;
		cursor: pointer;
	}
	button.primary {
		background: var(--accent-primary);
		color: var(--text-on-accent);
		border-color: transparent;
	}
	button:disabled {
		opacity: 0.55;
		cursor: default;
	}
	button:focus-visible {
		outline: var(--size-2) solid var(--accent-primary);
		outline-offset: var(--size-2);
	}
</style>
